export const ALL_PRODUCTS = 'ALL_PRODUCTS';
export const ALL_PRODUCTS_SUCCESS = 'ALL_PRODUCTS_SUCCESS';
export const ALL_PRODUCTS_FAILURE = 'ALL_PRODUCTS_FAILURE';

export const PRODUCT_BY_ID = 'PRODUCT_BY_ID';
export const PRODUCT_BY_ID_SUCCESS = 'PRODUCT_BY_ID_SUCCESS';
export const PRODUCT_BY_ID_FAILURE = 'PRODUCT_BY_ID_FAILURE';

export const HOMEPAGE_CONTENT = 'HOMEPAGE_CONTENT';
export const HOMEPAGE_CONTENT_SUCCESS = 'HOMEPAGE_CONTENT_SUCCESS';
export const HOMEPAGE_CONTENT_FAILURE = 'HOMEPAGE_CONTENT_FAILURE';

export const ALL_NAVIGATION = 'ALL_NAVIGATION';
export const ALL_NAVIGATION_SUCCESS = 'ALL_NAVIGATION_SUCCESS';
export const ALL_NAVIGATION_FAILURE = 'ALL_NAVIGATION_FAILURE';

export const CONTENT_PAGE = 'CONTENT_PAGE';
export const CONTENT_PAGE_SUCCESS = 'CONTENT_PAGE_SUCCESS';
export const CONTENT_PAGE_FAILURE = 'CONTENT_PAGE_FAILURE';

export const ERROR_MSG = 'ERROR_MSG';
export const SUCCESS_MSG = 'SUCCESS_MSG';

export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js